import useCanvas from "@/hooks/use-canvas";
import { clearCanvasExceptBackgroundAndTargets } from "@/utils/fabric-utils";
import { fabric } from "fabric";
import { Logger } from "@/utils/logger";

export interface UseHandleObjectsOptions {
  onRemoveObject?: (objectId: string) => void;
}

export const useHandleObjects = (options: UseHandleObjectsOptions = {}) => {
  const removeObjectFromCanvas = (objectId: string) => {
    const [canvas] = useCanvas();
    const targets = canvas?.getObjects().filter((obj: any) => obj.objectId === objectId) ?? [];
    if (targets.length) {
      targets.forEach((target: any) => canvas?.remove(target));
      canvas?.renderAll();
    }
    options.onRemoveObject?.(objectId);
  };

  const removeAllObjectsFromCanvas = () => {
    const [canvas] = useCanvas();
    clearCanvasExceptBackgroundAndTargets(canvas);
    canvas?.renderAll();
  };

  const addObjectToCanvas = (metadata: string) => {
    const [canvas] = useCanvas();
    if (!canvas || !metadata) return;

    try {
      const objectDefinition = JSON.parse(metadata);
      fabric.util.enlivenObjects([objectDefinition], (objects: any[]) => {
        objects.forEach((obj: any) => {
          // Mark object to skip onObjectCreated callback (from remote updates)
          obj.skipCallback = true;
          canvas.add(obj);
          delete obj.skipCallback;
        });
        canvas.renderAll();
      });
    } catch (error) {
      Logger.error("Failed to add canvas object", error);
    }
  };

  const editObjectFromCanvas = (objectId: string, metadata?: string) => {
    const [canvas] = useCanvas();
    const target = canvas?.getObjects().find((obj: any) => obj.objectId === objectId);
    if (target) {
      canvas?.remove(target);
    }
    if (!metadata) return;

    try {
      const objectDefinition = JSON.parse(metadata);
      fabric.util.enlivenObjects([objectDefinition], (objects: any[]) => {
        objects.forEach((obj: any) => {
          // Mark object to skip onObjectCreated callback (from remote updates)
          obj.skipCallback = true;
          canvas?.add(obj);
          delete obj.skipCallback;
        });
        canvas?.renderAll();
      });
    } catch (error) {
      Logger.error("Failed to edit canvas object", error);
    }
  };

  const logAllCanvasObjects = () => {
    const [_canvas] = useCanvas();
    // Logger.log(canvas?.getObjects().map((obj: any) => obj));
  };

  return {
    removeObjectFromCanvas,
    addObjectToCanvas,
    editObjectFromCanvas,
    logAllCanvasObjects,
    removeAllObjectsFromCanvas,
  };
};
